<template lang="pug">
  div.external-table
    v-data-table(
      :headers="headers"
      :items="data"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [5, 10, 20] }"
      dense
    )
</template>

<script>
import axios from 'axios'

export default {
  props: ['url'],
  data: () => ({
    data: [],
    loading: false,
    headers: []
  }),
  watch: {
    url() {
      this.init()
    }
  },
  methods: {
    init() {
      this.loading = true
      return axios.get(this.url).then(response => {
        this.loading = false
        this.headers = Object.keys(response.data[0]).map(header => {
          return {
            text: header,
            value: header,
            sortable: false,
            align: 'start',
            divider: true
          }
        })
        this.data = response.data
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="stylus">
  .external-table
    th, td
      font-family: 'Roboto Mono', monospace
</style>